import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as GenderActions from './gender.actions';
import { Gender } from '@app/shared/models/gender.model';

export const featureKey = 'gender';
export interface GenderState extends EntityState<Gender> {
  loading: boolean;
}

export const adapter: EntityAdapter<Gender> = createEntityAdapter<Gender>();

export const initialState: GenderState = adapter.getInitialState({
  loading: true,
});

const genderReducer = createReducer(
  initialState,
  on(GenderActions.loadGenders, (state, action) => ({
    ...state,
    loading: true,
  })),
  on(GenderActions.loadGendersSuccess, (state, action) =>
    adapter.addMany(action.genders, { ...state, loading: false })
  ),
  on(GenderActions.loadGendersFail, (state, action) => ({
    ...state,
    loading: false,
  })),
  on(GenderActions.clearGenders, (state) => adapter.removeAll(state))
);

export function reducer(state: GenderState | undefined, action: Action) {
  return genderReducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
